module.exports = __webpack_public_path__ + "static/media/imgpol.42e005a8.png";